import React, { useState, useEffect } from "react";
import {
  User,
  GraduationCap,
  Mail,
  Phone,
  MessageSquare,
  Trophy,
  Send,
} from "lucide-react";
import API_BASE_URL from "../../api/config";

// A simple and clean loader component
const Loader = () => (
  <div className="loader">
    <div className="circle"></div>
    <div className="circle"></div>
    <div className="circle"></div>
  </div>
);

const CampusAmbassadorForm = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [applicationForm, setApplicationForm] = useState({
    fullName: "",
    email: "",
    number: "",
    additionalMessage: "",
    portfolio: "",
    college: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleApplicationChange = (e) => {
    setApplicationForm({ ...applicationForm, [e.target.name]: e.target.value });
  };

  const handleApplicationSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    // Simulate API call delay
    await new Promise((resolve) => setTimeout(resolve, 2000));

    try {
      // Replace with your actual API endpoint URL
      const response = await fetch(
        `${API_BASE_URL}/api/campus_ambassador/upload`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(applicationForm),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to submit application. Please try again.");
      }

      await response.json();
      setSuccessMsg("Application submitted successfully! We will be in touch.");
      setApplicationForm({
        full_name: "",
        email: "",
        phone_number: "",
        additional_message: "",
        portfolio: "",
        college: "",
      });
    } catch (error) {
      setErrorMsg(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container-body">
      <div className={`campus-ambassador-page ${isVisible ? "visible" : ""}`}>
        <header className="form-header">
          <h1 className="title">Become a Campus Ambassador</h1>
          <p className="subtitle">
            Join our mission to cultivate the next generation of ethical
            leaders. Apply now to make an impact.
          </p>
        </header>

        <section className="application-form-section">
          <div className="application-form-card">
            <form
              onSubmit={handleApplicationSubmit}
              className="application-form-grid"
            >
              <div className="input-group">
                <User className="input-icon" />
                <input
                  type="text"
                  name="full_name"
                  placeholder="Full Name"
                  value={applicationForm.full_name}
                  onChange={handleApplicationChange}
                  required
                />
              </div>
              <div className="input-group">
                <GraduationCap className="input-icon" />
                <input
                  type="text"
                  name="college"
                  placeholder="College and Course"
                  value={applicationForm.college}
                  onChange={handleApplicationChange}
                  required
                />
              </div>
              <div className="input-group">
                <Mail className="input-icon" />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={applicationForm.email}
                  onChange={handleApplicationChange}
                  required
                />
              </div>
              <div className="input-group">
                <Phone className="input-icon" />
                <input
                  type="tel"
                  name="phone_number"
                  placeholder="Your WhatsApp Number"
                  value={applicationForm.phone_number}
                  onChange={handleApplicationChange}
                  required
                />
              </div>
              <div className="input-group textarea-full-width">
                <MessageSquare className="input-icon textarea-icon" />
                <textarea
                  name="additional_message"
                  placeholder="Why do you want to become a campus ambassador?"
                  value={applicationForm.additional_message}
                  onChange={handleApplicationChange}
                  rows="4"
                  required
                ></textarea>
              </div>
              <div className="input-group textarea-full-width">
                <Trophy className="input-icon textarea-icon" />
                <input
                  type="text"
                  name="portfolio"
                  placeholder="Portfolio or LinkedIn URL (Optional)"
                  value={applicationForm.portfolio}
                  onChange={handleApplicationChange}
                />
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    Submit Application <Send size={18} />
                  </>
                )}
              </button>
            </form>

            {successMsg && (
              <p className="form-message success-message">{successMsg}</p>
            )}
            {errorMsg && (
              <p className="form-message error-message">{errorMsg}</p>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default CampusAmbassadorForm;
